import { SlideTemplate } from "@/types/slideTemplate";
import { Template } from "@/types/template";

class TemplateService {

   public getNumberBySlideTemplate(template: Template, slideTemplate: SlideTemplate): number {
        for (const [key, value] of Object.entries(template.slideTemplate)) {
            if (value === slideTemplate) {
                return parseInt(key);
            }
        }
        return -1; 
    }

    public getSlideTemplateByNumber(template: Template, number: number): SlideTemplate | null {
        return template.slideTemplate[number] ?? null;
    }


}


export const templateService = new TemplateService(); 